import { InlineNotification } from '@carbon/react';

import { CLONE_NOTE } from '../utils';
import styles from './select-source-step.module.scss';

/** What cloning an existing package does with its decisions. */
const CLONE_HINT =
  'Assets reflect ownership as of the selected date. The source package’s include/exclude decisions carry over — tracts that were included without specific properties stay that way, so you don’t re-create exclusions.';

/**
 * Existing Package's hint, and the warning that the As of Date may change which
 * assets are included. The warning closes itself when dismissed and shows again
 * when Existing Package is picked again (this mounts afresh).
 *
 * @return {JSX.Element} The hint and the warning
 */
export function CloneNotes() {
  return (
    <>
      <p className={styles.hint}>{CLONE_HINT}</p>
      <InlineNotification
        kind="warning"
        lowContrast
        title="Cloning an existing package"
        subtitle={CLONE_NOTE}
        className={styles.cloneNotification}
      />
    </>
  );
}
